'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Fonts = require('./Fonts');

var _Fonts2 = _interopRequireDefault(_Fonts);

var _GlobalStyles = require('./GlobalStyles');

var _GlobalStyles2 = _interopRequireDefault(_GlobalStyles);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _Pane = require('./Pane');

var _Pane2 = _interopRequireDefault(_Pane);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var App = function App(_ref) {
  var children = _ref.children,
      reset = _ref.reset,
      fonts = _ref.fonts,
      globalStyles = _ref.globalStyles,
      props = _objectWithoutProperties(_ref, ['children', 'reset', 'fonts', 'globalStyles']);

  return _react2.default.createElement(
    _Pane2.default,
    _extends({ className: 'UIApp', minHeight: '100%', width: '100%', display: 'flex', flexAuto: true, flexDirection: 'column' }, props),
    fonts,
    globalStyles,
    children
  );
};

App.propTypes = {
  children: _propTypes2.default.any,
  reset: _propTypes2.default.element,
  fonts: _propTypes2.default.element,
  globalStyles: _propTypes2.default.element
};

App.defaultProps = {
  fonts: _react2.default.createElement(_Fonts2.default, null),
  globalStyles: _react2.default.createElement(_GlobalStyles2.default, { theme: _theme2.default })
};

exports.default = App;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/App.js
// module id = 1113
// module chunks = 0